<template>
  <a-form-item
    :label="varLabel"
    :label-col="formItemLayout.labelCol"
    :wrapper-col="formItemLayout.wrapperCol"
    has-feedback
  >
    <a-auto-complete
      :size="size"
      :disabled="disabled"
      v-decorator="[
          `${varName}`,
          { 
            rules: [{ required: varRequired, message: message }], 
            initialValue: varInitial},]"
      :dataSource="data"
      :filterOption="filterOption"
      :placeholder="message"
    />
    <a-alert :message="description" type="info" showIcon style="margin-top:5px;" v-if="description" />
  </a-form-item>
</template>

<script>
import { formLayoutMixin } from "@/mixins/formLayout";

export default {
  mixins: [formLayoutMixin],
  props: {
    varName: String,
    varLabel: String,
    varInitial: [String, Array],
    varRequired: {
      type: Boolean,
      default: false
    },
    formLayout: String,
    size: String,
    description: [String, null],
    disabled: {
      type: Boolean,
      default: false
    },
    data: Array
  },
  computed: {
    message() {
      return `Please select ${this.varLabel.toLowerCase()}`;
    }
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toUpperCase()
          .indexOf(input.toUpperCase()) >= 0
      );
    }
  }
};
</script>
